<template>
  <dvi :class="classes">
    {{ text }}
  </dvi>
</template>

<script setup>
import { onMounted, defineProps, computed } from "vue";

const props = defineProps({
  text: {
    type: String,
  },
  type: {
    type: String,
    required: false,
    default: null
  },
  close: Function,
});

const hide = () => {
  setTimeout(() => {
    close();
  }, 3000);
};

const classes = computed(() => {
  const baseClasses = 'notification';
  let dynamicClasses = '';

  if (props.type) {
    dynamicClasses = props.type;
  }

  return `${baseClasses} ${dynamicClasses}`;
})

onMounted(() => {
  hide();
});
</script>

<style lang="scss" scoped>
.notification {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 100;
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  padding: 0.5rem 1rem;
  opacity: 0;
  transform: translateY(-20px);
  animation: slideDown 0.5s forwards;
  background: #ff6358;

  &.success {
    background: #65a30d;
  }
}

@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>